export const promotionInfo = {
	title: "Promotion information",
	description:
		"Set all the necessary parameters to create a specialized promotion for your customers.",
	channelAndAudience: {
		title: "Promotion channel and target audience",
		description: "Choose the distribution channel and who can receive the promotion.",
		channelTitle: "Choose the channel type",
		channelInfo:
			"Sets the sales channel where the promotion will be distributed and applied.",
		channels: {
			cashlessMesas: {
				title: "Cashless/Tables",
				description: "Promotion applied to cashless or table sales",
			},
			ficha: {
				title: "Ticket",
				description: "Promotion applied to ticket sales",
			},
			totemFicha: {
				title: "Ticket Kiosk",
				description: "Promotion applied to the ticket kiosk",
			},
		},
		audienceTitle: "Who can receive this promotion?",
		audienceInfo:
			"Sets who can receive the promotion and whether the customer's CPF must be provided at the sale to apply it.",
		audience: {
			everybody: "All customers",
			identifiedCpf: "Customer identified by CPF",
		},
		identifiedCpfWarning:
			"Kiosks must have an internet connection for promotions with customer identification.",
	},
	generalData: {
		title: "Promotion general data",
		description:
			"Enter the promotion name and description and the locations it will be assigned to.",
	},
	promotionName: {
		label: "Promotion name",
		placeholder: "Enter the name of the promotion",
	},
	promotionDescription: {
		label: "Promotion description",
		placeholder: "Enter the description of the promotion",
	},
	expiration: {
		label: "Expiration",
		info:
			"The promotion will be valid until the selected date. When the expiration date comes, the promotion will be inactive and you can change the expiration date.",
		notExpire: "Does not expire",
	},
	automaticMessage: {
		label: "Automated messages to customers",
		info:
			"All customers who win the promotion receive automatic messages from the selected channel. These shipments cost",
		sendMessage: "Send automatic messages",
	},
	whatsUp: {
		label: "View promotions on 'Whats Up'",
		info: "All enabled promotions will be displayed in 'Whats Up'.",
		showPromotions: "View promotions on 'Whats Up'",
	},
	places: "Promotion locations",
	placesAll: "All",
	errors: {
		requiredField: "This field is required",
		dateFormat: "Invalid date format",
		dayDiff: "At least one day difference required",
		selectPlace: "Please select at least one location",
		maxUses:
			"Value must not exceed the quantity of products defined in the previous step",
	},
};
